export class SettingApi {

	public static getApiBaseUrl = (apiName: string = "default"): string | undefined => {

		// Get Api Configuration String From Local Storage
		const configurationsString: string | null = sessionStorage.getItem("Configuration.Api");

		// Check For Configuration
		if (configurationsString) {

			// Parse JSON
			const configurations = JSON.parse(configurationsString);

			// Get Specific Configuration
			const configuration = configurations[apiName];

			// Check For Specific Configuration
			if (configuration) {

				// Return Base Url
				return configuration.baseUrl as string;
			}
		}

		// Return Nothing
		return undefined;
	}
}
